import React from 'react';
import { LoaderContainer } from './styles'
import { Spinner } from '../spinner'
import { Compass } from '../compass'
import { Fade } from '../fade';

export const Loader = ({ isLoading, children, revers, color, bgColor, top, ...fadeParams }) => {
    return (
        <>
            <Fade isShow={isLoading} {...fadeParams}><LoaderContainer top={top} noBg={revers} bgColor={revers ? color : bgColor}><Compass dark={revers} /><Spinner isLoading color={revers ? bgColor : color} /></LoaderContainer></Fade>
            {children}
        </>
    )
}
